export default function Footer() {
  return (
    <footer className="mt-10 bg-[#F3F4F6]">
      <div className="mx-auto max-w-[1700px] p-6 lg:p-8">
        <div className="grid gap-8 lg:grid-cols-4">

          <div>
            <a href="#" className="font-medium text-black">نبذة عن الشركة</a>
            <div className="mt-2 space-y-1 text-sm">
              <a className="block hover:underline" href="#">نبذة تاريخية</a>
              <a className="block hover:underline" href="#">كلمة نائب الرئيس</a>
              <a className="block hover:underline" href="#">أعضاء مجلس الإدارة</a>
              <a className="block hover:underline" href="#">الفريق الإداري</a>
              <a className="block hover:underline" href="#">حوكمة الشركات</a>
              <a className="block hover:underline" href="#">مكافحة غسل الأموال</a>
              <a className="block hover:underline" href="#">دليل حماية العملاء</a>
            </div>
          </div>

          <div>
            <a href="#homeServices" className="font-medium text-black">خدمات الشركة</a>
            <div className="mt-2 space-y-1 text-sm">
              {["قرض نقدي","قرض سياره","قرض اسكاني","قرض تعليمي","معدات بحرية","قرض أثاث","أجهزة كهربائية","قرض تجاري"].map(x=>(
                <a key={x} className="block hover:underline" href="#homeServices">{x}</a>
              ))}
            </div>
          </div>

          <div>
            <a href="#" className="font-medium text-black">الأخبار والمعلومات المالية</a>
            <div className="mt-2 space-y-1 text-sm">
              <a className="block hover:underline" href="#">تقارير مالية</a>
              <a className="block hover:underline" href="#">نتائج الاجتماع</a>
            </div>
          </div>

          <div>
            <a href="#" className="font-medium text-black">إتصل بنا</a>
            <div className="mt-2 space-y-1 text-sm">
              <a className="block hover:underline" href="#">شكاوي العملاء</a>
              <a className="block hover:underline" href="#">فروعنا</a>
              <a className="block hover:underline" href="#">الأسئلة المشهورة</a>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="font-medium">تواصل معنا</div>
            <div className="mt-2 flex gap-2">
              <img src="/assets/instagram.png" width="32" height="32" alt="ig"/>
              <img src="/assets/facebook.png"  width="32" height="32" alt="fb"/>
              <img src="/assets/twitter.png"   width="32" height="32" alt="tw"/>
              <img src="/assets/youtube.png"   width="32" height="32" alt="yt"/>
              <img src="/assets/linkedin.png"  width="32" height="32" alt="in"/>
            </div>
          </div>

          <div>
            <div className="font-medium">اتصل بنا</div>
            <div className="mt-2 flex items-center gap-2">
              <img src="/assets/whatsapp.png" width="32" height="32" alt="wa"/>
              <img src="/assets/email.png"    width="32" height="32" alt="mail"/>
              <img src="/assets/phone.png"    width="32" height="32" alt="phone"/>
            </div>
          </div>

          <div>
            <div className="font-medium">حمل التطبيق</div>
            <div className="mt-2 flex gap-2">
              <img src="/assets/app-store.png" width="120" height="40" alt="appstore"/>
              <img src="/assets/play-store.png" width="120" height="40" alt="playstore"/>
            </div>
          </div>
        </div>

        <div className="mt-6 border-t pt-3 text-center text-sm">
          © {new Date().getFullYear()} Commercial Facilities CO. All rights are reserved.
        </div>
      </div>
    </footer>
  );
}
